module.exports = __webpack_public_path__ + "img/dribbble-circle.b9c09716.svg";